export const getBundlePdpData = data => {
  const {
    BundleDescription_s: name = "",
    BundleID_s: sku = "",
    BundleNarrativeDescription_s: desc = "",
    ColorFinish_ss: colorFinish = [],
    BundleList_ss: bundleList = [],
    BundleComponent_ss: bundleComponents = [],
    BundleLocalCategory_s: productLocalCategory = "",
    BundleImageURL_s: bundleIMageURL = "",
  } = data || {}

  return {
    pdpDetails: {
      sku,
      name,
      desc,
      productLocalCategory,
    },
    colorDetails: getColorDetails(colorFinish),
    bundleItems: getBundleItemsData({ bundleComponents, bundleList }),
    imageGallery: getImageGalleryData({ bundleList, bundleIMageURL }),
  }
}

const getBundleItemsData = data => {
  const { bundleComponents = [], bundleList = [] } = data || {}
  const productGroupList = []
  Object.entries(bundleList).forEach(([key, value], i) => {
    const products = []

    value.forEach(item => {
      const {
        BundleSku_s: sku = "",
        title_s: title = "",
        ProductLocalCategory_s: category = "",
        masterSKU_s: masterSku = "",
        slug_s: slug = "",
        ["productImages.labelWithUrl_ss"]: variantImages = [],
        ["Color.Name.Details_ss"]: variantColorNames = [],
        ["Color.SKU.Details_ss"]: colorVariant = [],
        ProductWebFeatures_ss: productWebFeatures = [],
        ProductBadgeInfo_ss: productBadgeInfo = [],
        ProductDimensionAttributes: productDimensionAttributes = [],
        ctProductType_s: productType = "",
        ProductDimensionAttributesValues: productDimensionAttributesValues = [],
        ["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"]:
          specPDFFileName = [],
        ["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"]:
          installGuidesFiles = [],
        caterogy1_s: primaryCategory = "",
        ProductBrandNameDisplay_t: productBrandName = "",
        productName_s: productName = "",
        RegionBrandName_s: regionBrandName = "",
        ProductWaterSense_ss: productWaterSense = false,
      } = item || {}

      const colorFinish = variantColorNames.map(color => {
        const [name = "", swatch = ""] = color.split("|")
        return {
          name,
          swatch,
        }
      })

      const colorDetails = colorVariant.map(color => {
        const [name = "", swatch = "", sku, , , customerFacingSku = ""] =
          color.split("|")
        return {
          sku,
          name,
          swatch,
          customerFacingSku,
        }
      })

      const imageDetails = variantImages.map(image => {
        const variant = image.split("|")

        return {
          sku: variant.at(0),
          id: variant.at(1),
          imageUrl: variant.at(-1),
        }
      })

      const swatchName = colorFinish.at(0)?.name || ""

      const { id: assetId = "", imageUrl = "" } = getSelectedColorImage({
        colorDetails,
        imageDetails,
        swatchName,
      })

      products.push({
        imageUrl,
        assetId,
        sku,
        masterSku,
        slug,
        category,
        title,
        imageDetails,
        colorFinish,
        colorDetails,
        productWebFeatures,
        productBadgeInfo,
        productDimensionAttributes,
        productType,
        productDimensionAttributesValues,
        specPDFFileName,
        installGuidesFiles,
        primaryCategory,
        productBrandName,
        productName,
        regionBrandName,
        productWaterSense,
      })
    })
    const bundleName = bundleComponents[i]?.split("|").at(1) || ""
    productGroupList.push({ name: bundleName, products })
  })

  return productGroupList
}

const getColorDetails = (colorFinish = []) => {
  return colorFinish.map((color = "") => {
    const [name = "", swatch = ""] = color.split("|")
    return {
      name,
      swatch,
    }
  })
}

const getImageGalleryData = ({ bundleList = [], bundleIMageURL = "" }) => {
  const bundleListImages = Object.entries(bundleList).map(([key, value]) => {
    return value.map(each => {
      return {
        ProductImageURL: each[`productImages.labelWithUrl_ss`],
        ProductVideoID: each?.ProductYoutubeID_s || "", // "WVed-4iVx2w|wcwFfblokgA",
        sku: each.sku_s,
        masterSKU: each.masterSKU_s,
      }
    })
  })

  const imageData = {
    bundleIMageURL: bundleIMageURL || "",
    bundleListImages: bundleListImages,
  }
  return imageData
}

export const getSelectedColorImage = data => {
  const { colorDetails = [], imageDetails = [], swatchName = "" } = data

  const { sku = "", customerFacingSku = "" } =
    colorDetails.find(e => e.name === swatchName) || {}
  const colorSku = sku || colorDetails.at(0)?.sku || ""
  const selectedItem = imageDetails.find(e => e.sku === colorSku) || {}
  const { imageUrl = "" } = selectedItem || {}

  return {
    ...selectedItem,
    imageUrl: `${imageUrl}?wid=300&hei=300&bgc=f9f9f9`,
    customerFacingSku,
  }
}

export const isAvailableInventory = data => {
  const { inventory = [], sku } = data || {}
  const { availableQuantity = 0 } =
    inventory.find(item => item.sku === sku) || {}
  return availableQuantity > 0
}
